import { useEsignAvailabilityQuery } from 'core/graphql';

import { useEsignPermissions } from './useEsignPermissions';

export interface IEsignAvailability {
  /** `ESIGN_ENABLED`: можно создавать и отправлять договоры. */
  enabled: boolean;
  /** Письмо со ссылкой реально уйдёт (подписанту или на тестовый адрес). */
  mailEnabled: boolean;
  /** Письмо уйдёт на тестовый адрес, а не подписанту. */
  mailRedirected: boolean;
  /**
   * Сократитель настроен (`SHORTLINK_BASE_URL`). Нет — у договора только
   * ссылка Documenso, и кнопка «короткая ссылка» не показывается вовсе, а не
   * отказывает после клика.
   */
  shortLinksEnabled: boolean;
  loading: boolean;
}

/**
 * ТЗ 0076, переходный период: PandaDoc и договоры ERP живут одновременно.
 *
 * Пока флаг на сервере выключен, ERP выглядит как до ТЗ 0076 — прячутся
 * пункт меню, команды палитры и кнопки «Новый договор» / отправки. Просмотр
 * уже созданных договоров от флага НЕ зависит: вебхуки и сверка доводят их
 * до подписи и зачисления и при выключенном флаге.
 *
 * Пока ответа нет (или сервер старый и поля не знает) — считаем выключенным:
 * мигнуть кнопкой хуже, чем показать её на полсекунды позже.
 */
export const useEsignAvailability = (): IEsignAvailability => {
  const { canOpenPage } = useEsignPermissions();
  const { data, loading } = useEsignAvailabilityQuery({
    skip: !canOpenPage,
    fetchPolicy: 'cache-first',
  });
  const settings = data?.esignSettings;
  return {
    enabled: Boolean(settings?.enabled),
    mailEnabled: Boolean(settings?.mailEnabled),
    mailRedirected: Boolean(settings?.mailRedirected),
    shortLinksEnabled: Boolean(settings?.shortLinksEnabled),
    loading,
  };
};
